import { render, staticRenderFns } from "./ConfiguratorMobileSubcategoryCollapse.vue?vue&type=template&id=2b8679ea&scoped=true&"
import script from "./ConfiguratorMobileSubcategoryCollapse.vue?vue&type=script&lang=ts&"
export * from "./ConfiguratorMobileSubcategoryCollapse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8679ea",
  null
  
)

export default component.exports